import styled from 'styled-components'
import { ChevronDownIcon, ScheduleIcon } from '@shipt/design-system-icons'
import { trackElementClicked } from '@/features/shared/analytics/element'
import { Button } from '@shipt/design-system-buttons'
import { useHandleDialog } from '@/features/shared/state/Dialog/useHandleDialog'
import { DynamicStoreInfoDrawer } from '@/features/shop/components/Drawer/StoreInfoDrawer/DynamicStoreInfoDrawer'
import { NextDeliveryWindowText } from '@/features/shared/components/Headers/NextDeliveryWindowText'

type Props = {
  className?: string
}

export const NextDeliveryWindow = ({ className }: Props) => {
  const { openDialog } = useHandleDialog()
  const openStoreDrawer = () => {
    trackElementClicked({
      type: 'button',
      link_name: 'delivery_window_link',
      display_format: 'horizontal_list',
    })
    openDialog(DynamicStoreInfoDrawer)
  }

  return (
    <DeliveryTimeButton
      className={className}
      variant="tertiary"
      size="sm"
      onClick={openStoreDrawer}
      leadingIcon={ScheduleIcon}
      trailingIcon={ChevronDownIcon}
    >
      <NextDeliveryWindowText isPill size="md" />
    </DeliveryTimeButton>
  )
}

const DeliveryTimeButton = styled(Button)`
  min-width: 14em;
  display: flex;
  align-items: center;
  justify-content: space-between;
`
